<div fxLayoutGap="24px" fxLayout="column" fxLayoutAlign="start center" mat-dialog-content>

  <img src="../../assets/images/logos/ls-premium.png" alt="Little SIS Premium Logo" class="logo">

  <div fxLayout="row" [ngClass]="{'red-600-fg': templateData.showIcon}"  fxLayoutAlign="center center" fxLayoutGap="16px">
    <mat-icon *ngIf="templateData.showIcon" class="icon-20">warning</mat-icon>
    <div>{{templateData.expiryMessage}}</div>
  </div>
  <p *ngIf="templateData.lastTierExpiration"><strong>Your {{templateData.lastTierExpiration.type}} license expired on {{templateData.lastTierExpiration.date | date:'shortDate'}}</strong></p>
  <p>
    <strong>With your license expired you will only be able to perform a limited set of actions.</strong>
    <app-help-popover-button></app-help-popover-button>
  </p>

  <div *ngIf="templateData.showRecheckButton || templateData.showRenewalButton"
       fxLayout="row"
       fxLayoutAlign="start center"
       fxLayoutGap="24px">
    <button *ngIf="templateData.showRenewalButton" class="renew-button" mat-raised-button (click)="requestRenewal()">START
      YOUR RENEWAL
    </button>
    <button *ngIf="templateData.showRecheckButton" class="renew-button" mat-raised-button
            (click)="recheckLicenseState()">RE-CHECK LICENSE
    </button>
  </div>

</div>

<div fxLayoutAlign="space-between center" mat-dialog-actions>
  <p *ngIf="isSuperAdmin()" class="small-strong">
    **Please note, data is deleted 90 days after the license expiration date.
  </p>
  <button mat-raised-button class="grey-button" (click)="closeDialog()">CLOSE</button>
</div>

